// extracted by mini-css-extract-plugin
export default {"card":"style_card__wRhbx","card__title":"style_card__title__z6XWW","card__cta":"style_card__cta__zeVpA"};